<template>
  <div class="container">
    <div class="weui-navbar daojia-navbar">
        <div class="daojia-navbar-left"><router-link to="/storage-abstract"><span class="icon-chevron-left"></span></router-link></div>
        <h1 class="daojia-navbar-middle daojia-navbar-middle_logo"><a href="#"><img src="../../assets/img/global/logo.png"></a></h1>
        <div class="daojia-navbar-right">
        </div>
    </div>
    <div class="image-box">
        <img src='/static/img/services/storage1.jpg'>
        <img src='/static/img/services/storage2.jpg'>
        <img src='/static/img/services/storage3.jpg'>
    </div>
    <div class="btn-box-fix">
      <div class="slogan">具体费用以及服务详情，客服将为您解答</div>
      <div class="btn-container">
        <a href="javascript:void(0)" class="btn active" @click="$router.push('/service/form/storage?back=1')">下单仓储服务</a>

<!--         <a href="tel:047774777" class="btn active"  v-if="workingHours<9 || workingHours>21"> 下单仓储服务</a>
        <a href="javascript:void(0)" id="chatnow" class="btn active"  v-if="workingHours>=9 && workingHours<=21"> 下单仓储服务</a> -->
      </div>
    </div>
    <img :src="pixelURL('CangChu','baojia')" class="hide">
  </div>
</template>

<script>
export default {
  name: 'storage',
  data () {
    return {
      order:{}
    }
  },
  methods: {

  },
  computed: {
    workingHours: function () {
      let d = new Date();
      let time = d.getHours();
      return time;
    }
  },
  components: {
  },
  mounted: function () {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../../assets/css/base.scss";
.container{
  padding-top:80px;
}

.title{
  font-size:1.4em;
}
.empty{
  padding:0 20vw;
  text-align:center;
  margin-top:2vh;
  width:100vw;
  box-sizing:border-box;
  color:#999;
  a{
    color:#fe9567;
  }
}
.image-box{
  img{
    width:100%;
  }
  font-size:0;
}
.btn{
  margin-top:20px;
}
.text{
  text-align:center;
  font-size:1.2em;
  color:#888;
}

.daojia-navbar {
    position: fixed;
    background: rgba(255, 255, 255, 0.95);
    padding: 8px 10px;
    box-sizing: border-box;
    height: 50px;
}

.daojia-navbar-left {
    display: block;
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    flex: 1;
    text-align: left;
    span{
      font-size: 2em;
      color: #666;
    }
}

.daojia-navbar-middle_logo img{
    height:34px;
}

.daojia-navbar-middle {
    display: block;
    -webkit-box-flex: 2;
    -webkit-flex: 2;
    flex: 2;
    font-smoothing: antialiased;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    font-family: sans-serif;
    font-size: 1.2em;
    line-height: 1.3;
    font-weight: bold;
}

.daojia-navbar-right {
    font-size: 14px;
    line-height: 26px;
    display: block;
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    flex: 1;
    text-align: right;
}

.btn-box-fix .btn.active{
  margin-left:0;
  margin-top:0;
}
.slogan{
  margin-top:6px;
  margin-bottom:5px;
  font-size:0.8em;
}
</style>



// WEBPACK FOOTER //
// src/pages/service/storage.vue